// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h2.features-01-heading {
    text-align: center;
    max-width: 741px;
    margin-left: auto;
    margin-right: auto;
}

.body-02.features-01-card-subtext {
    color: var(--silver);
    margin-top: 16px;
}

.body-02.features-01-card-subtext._1 {
    max-width: 570px;
}

.features-01-card-wrap {
    margin-top: 72px;
    padding-right: 20px;
    padding-left: 20px;
}

.features-01-card-top {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid;
}

.features-01-card {
    border: 1px solid var(--gordons-green-bright);
    background-color: var(--approx-nero);
    border-radius: 16px;
    flex: 0 1 auto;
    padding: 24px 24px 40px;
}

.features-01-card._1 {
    flex: none;
    width: 760px;
}

.features-01-card-image-box {
    justify-content: center;
    align-items: center;
    display: flex;
}

.features-01-card-image-1 {
    width: 712px;
    height: 280px;
}

.features-01-card-text-wrap {
    margin-top: 32px;
}

.features-01-card-bottom {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 40px;
    display: grid;
}

.features-01-card-image-2 {
    width: 312px;
    height: 280px;
}

.features-01-card-image-3 {
    width: 280px;
    height: 280px;
}


.features-01 {
    margin-top: 40px;
}

@media screen and (max-width: 991px) {

    .features-01-card-wrap {
        margin-top: 60px;
    }

    .features-01-card-top {
        grid-column-gap: 40px;
        grid-template-columns: 1fr;
    }

    .features-01-card {
        padding: 40px;
    }

    .features-01-card._1 {
        width: 100%;
    }

    .features-01-card-image-1 {
        width: 100%;
        height: auto;
    }

    .features-01-card-text-wrap {
        margin-top: 28px;
    }

    .features-01-card-bottom {
        grid-template-columns: 1fr;
    }

    .features-01-card-image-2, .features-01-card-image-3 {
        width: 100%;
        height: 100%;
    }
}

@media screen and (max-width: 767px) {

}

@media screen and (max-width: 479px) {
    .body-02.features-01-card-subtext {
        margin-top: 10px;
    }

    .features-01 {
        margin-top: 30px;
    }

    .features-01-card-wrap {
        margin-top: 40px;
    }

    .features-01-card-top {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
    }

    .features-01-card {
        padding: 20px;
    }

    .features-01-card-text-wrap {
        margin-top: 20px;
    }

    .features-01-card-bottom {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        margin-top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Features.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,mBAAmB;IACnB,cAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;AAEA;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":[".h2.features-01-heading {\n    text-align: center;\n    max-width: 741px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.body-02.features-01-card-subtext {\n    color: var(--silver);\n    margin-top: 16px;\n}\n\n.body-02.features-01-card-subtext._1 {\n    max-width: 570px;\n}\n\n.features-01-card-wrap {\n    margin-top: 72px;\n    padding-right: 20px;\n    padding-left: 20px;\n}\n\n.features-01-card-top {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid;\n}\n\n.features-01-card {\n    border: 1px solid var(--gordons-green-bright);\n    background-color: var(--approx-nero);\n    border-radius: 16px;\n    flex: 0 auto;\n    padding: 24px 24px 40px;\n}\n\n.features-01-card._1 {\n    flex: none;\n    width: 760px;\n}\n\n.features-01-card-image-box {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n\n.features-01-card-image-1 {\n    width: 712px;\n    height: 280px;\n}\n\n.features-01-card-text-wrap {\n    margin-top: 32px;\n}\n\n.features-01-card-bottom {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 40px;\n    display: grid;\n}\n\n.features-01-card-image-2 {\n    width: 312px;\n    height: 280px;\n}\n\n.features-01-card-image-3 {\n    width: 280px;\n    height: 280px;\n}\n\n\n.features-01 {\n    margin-top: 40px;\n}\n\n@media screen and (max-width: 991px) {\n\n    .features-01-card-wrap {\n        margin-top: 60px;\n    }\n\n    .features-01-card-top {\n        grid-column-gap: 40px;\n        grid-template-columns: 1fr;\n    }\n\n    .features-01-card {\n        padding: 40px;\n    }\n\n    .features-01-card._1 {\n        width: 100%;\n    }\n\n    .features-01-card-image-1 {\n        width: 100%;\n        height: auto;\n    }\n\n    .features-01-card-text-wrap {\n        margin-top: 28px;\n    }\n\n    .features-01-card-bottom {\n        grid-template-columns: 1fr;\n    }\n\n    .features-01-card-image-2, .features-01-card-image-3 {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n\n}\n\n@media screen and (max-width: 479px) {\n    .body-02.features-01-card-subtext {\n        margin-top: 10px;\n    }\n\n    .features-01 {\n        margin-top: 30px;\n    }\n\n    .features-01-card-wrap {\n        margin-top: 40px;\n    }\n\n    .features-01-card-top {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n    }\n\n    .features-01-card {\n        padding: 20px;\n    }\n\n    .features-01-card-text-wrap {\n        margin-top: 20px;\n    }\n\n    .features-01-card-bottom {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        margin-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
